import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const calendarInventoryMovementsQueryAtom = createQueryAtomFactory(
  'calendar.inventoryMovements',
  (params: { fromDate: string; toDate: string; facilityId?: string }) => ({
    inventoryMovements: {
      __args: {
        filter: {
          fromOccurredAt: `${params.fromDate}T00:00:00Z`,
          toOccurredAt: `${params.toDate}T23:59:59Z`,
          ...(params.facilityId ? { facilityId: params.facilityId } : {}),
        },
        pagination: {
          limit: 500,
          offset: 0,
        },
      },
      entries: {
        id: true,
        itemId: true,
        movementType: true,
        originTransactionType: true,
        occurredAt: true,
        status: true,
        quantity: {
          value: true,
          unit: true,
        },
        totalCost: {
          amount: true,
          currencyCode: true,
        },
        facilityId: true,
        facility: {
          id: true,
        },
        item: {
          id: true,
          name: true,
          skuNumber: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
);
